import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { finalize } from 'rxjs';

import { Addon, Agreement } from '../schemas';
import { AgreementService, Messenger } from '../service';

export interface RemoveAddonData {
  addon: Required<Addon>;
  agreement: Agreement;
}

@Component({
  selector: 'lcm-remove-addon-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatProgressBarModule],
  template: `
    <h2 mat-dialog-title>Remove addon</h2>
    <mat-dialog-content> Are you sure you want to remove the addon "{{ data.addon.AddonName }}"? </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close [disabled]="pending()">Cancel</button>
      <button matButton [disabled]="pending()" (click)="remove()">Confirm</button>
    </mat-dialog-actions>

    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
})
export class RemoveAddonDialog {
  agreements = inject(AgreementService);
  data = inject(MAT_DIALOG_DATA) as RemoveAddonData;
  hostDialog = inject(MatDialogRef);
  messenger = inject(Messenger);

  pending = signal(false);

  remove() {
    this.pending.set(true);

    this.agreements
      .removeAddon(this.data.agreement.AgreementNumber, this.data.addon.Id)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: () => this.hostDialog.close(this.data.addon),
        error: this.messenger.handleHttpError,
      });
  }
}
